import React from 'react';

export default function RefundPolicy() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-30">
          Refund Policy – PipPlus Tech
        </h1>

        {/* Content */}
        <div className="space-y-20 text-left text-gray-300" style={{ fontSize: '20px' }}>
          <p>
            At <strong className="text-white">PipPlus Tech</strong>, we strive to provide high-quality digital tools and services that meet your needs.
            Because of the nature of our platform, we have established the following refund guidelines to ensure clarity and fairness.
          </p>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>1.Digital Product Access</h2>
            <p>
              Our products and services are delivered digitally and typically provide immediate access upon purchase or subscription activation.
              Due to this instant delivery, we generally do not offer refunds once access is granted.
            </p>
          </div>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>2.Subscription Plans</h2>
            <p>
              You may cancel your subscription at any time. Your subscription will remain active until the end of the current billing cycle.
              We do not provide refunds or credits for partial subscription periods or unused time.
            </p>
          </div>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>3.Exceptions and Refund Requests</h2>
            <p>Refunds may be considered in exceptional circumstances such as:</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Duplicate or incorrect billing.</li>
              <li>Technical issues that prevent access to the service, confirmed by our support team.</li>
              <li>Unauthorized transactions.</li>
            </ul>
            <p className="mt-4">
              To request a refund, please contact us within 7 days of the transaction at{' '}
              <a href="mailto:support@PipPlus Tech.com" className="text-blue-400 underline">
                support@PipPlus Tech.com
              </a>{' '}
              with relevant details. We will review your request and notify you of the decision within 10 business days.
            </p>
          </div>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>4.No Refunds for Change of Mind</h2>
            <p>
              Refunds will not be granted for reasons such as change of mind, dissatisfaction after using the service,
              or failure to use the service.
            </p>
          </div>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>5.Contact Us</h2>
            <p>
              For questions or to request support, please contact:<br />
              Email:{' '}
              <a href="mailto:support@PipPlus Tech.com" className="text-blue-400 underline">
                support@PipPlus Tech.com
              </a><br />
              Address: Al Moosa Tower, Shaikh Zayed Road, Near Future Museum, Dubai
            </p>
          </div>

          <div>
            <h2
  className="text-yellow-300 mb-0 mt-16"
  style={{ fontSize: '30px' }}
>6.Policy Updates</h2>
            <p>
              We reserve the right to update this policy at any time. Updates will be posted on our website with an updated effective date.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
